import { bitcashPrivateRoom } from 'app-view/hooks/use-realtime'

export const useRealTimeTrustNetworkIncomingTrustRequests = () => {
  const _incomingTrustRequests = bitcashPrivateRoom.useColyseusState(
    (state) => state.incomingTrustRequest,
  )
  const incomingTrustRequests = _incomingTrustRequests ? _incomingTrustRequests.toArray() : []
  return incomingTrustRequests
}
